import React from 'react';
import '/public/css/pages/story.css';
import AdvertisementBanner from '../components/Advertisement/AdvertisementBanner';
import CollectionConfig from 'config/collectionBanner.json';
import { usePathname } from 'next/navigation';

interface AdInsert {
  type?: string;
  id?: string;
  sizes?: number[][];
  sizeMap?: { [key: number]: number[] };
  cmsId?: string;
  primaryCollection?: string;
  collections?: string[];
  position?: string;
}

interface ContentGridProps {
  h1Text?: string;
  children: React.ReactNode;
  className?: string;
  sidebar?: React.ReactNode;
  mainClassName?: string;
  adInsert?: AdInsert | null;
}

const ContentGrid: React.FC<ContentGridProps> = ({
  h1Text,
  children,
  className,
  sidebar,
  mainClassName = 'story-content',
  adInsert,
}) => {
  return (
    <div className={className}>
      {`/${CollectionConfig.slug}` === usePathname() ? (
        <div className="hdg-section collection-banner">
          <div className="collection-banner-first-area">
            <h1 className="collection-banner-logo">
              <img
                src={`${CollectionConfig.logo}`}
                alt={CollectionConfig.name || h1Text}
              />
            </h1>
            <div className="collection-banner-images">
              {CollectionConfig.images.map((img, i) => {
                return (
                  <div key={i}>
                    <img src={img.path} alt={img.alt} />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        h1Text && (
          <div className="hdg-section">
            <div className="container hdg-section-text">
              <h1>{h1Text}</h1>
              <div className="premium-underwriting">
                <AdvertisementBanner
                  id="premium_ad"
                  adUnitPath="ad/path/goes/here"
                  sizes={[[320, 25]]}
                  sizeMap={{ 0: [320, 25] }}
                  customCss="underwriting"
                />
              </div>
            </div>
          </div>
        )
      )}

      <div className="container grid grid-4col grid-3-1">
        <div className={`grid-primary ${mainClassName}`}>
          {children}
          {adInsert && (
            <AdvertisementBanner
              id={adInsert.id}
              sizes={adInsert.sizes}
              sizeMap={adInsert.sizeMap}
              cmsId={adInsert.cmsId}
              primaryCollection={adInsert.primaryCollection}
              collections={adInsert.collections}
              position={adInsert.position}
            />
          )}
        </div>
        {sidebar && <div className="story-sidebar">{sidebar}</div>}
      </div>
    </div>
  );
};

export default ContentGrid;
